<div [formGroup]='inputForm' class='ResetAccountPasswordDialog'>
  <div class='ResetAccountPasswordDialog-row'>
    <p>New Password</p>
    <app-text-field
      [allowViewPassword]='true'
      [canCopy]="true"
      formControlName='password'
      placeholder='New password'
      type='password'></app-text-field>
  </div>
  <div class='ResetAccountPasswordDialog-row'>
    <p>Re-enter password</p>
    <app-text-field
      [allowViewPassword]='true'
      [canCopy]="true"
      formControlName='password_repeat'
      placeholder='Re-enter password'
      type='password'></app-text-field>
    <mat-error
      *ngIf='
        (passwordRepeat?.touched || passwordRepeat?.dirty) &&
        passwordRepeat?.errors?.passwordNotPatch
      '
    >Passwords did not match
    </mat-error
    >
  </div>
</div>
